import type { PropsWithChildren } from "react";
import { createContext, useContext } from "react";

export function createMobxStoreProvider<Store>(name: string) {
  const Context = createContext<Store | null>(null);

  const Provider = (
    props: PropsWithChildren<{
      store: Store;
    }>,
  ) => {
    const { children, store } = props;
    return <Context.Provider value={store}>{children}</Context.Provider>;
  };
  const useStore = () => {
    const context = useContext(Context);
    if (!context) {
      throw Error(`use${name}Store must be used within ${name}StoreProvider`);
    }
    return context;
  };
  return {
    Context,
    Provider,
    useStore,
  };
}
